export default __webpack_public_path__ + "static/media/SePeru-1.f8cac0e0.jpg";